import { Injectable } from '@angular/core';
import { Store, guid } from '@datorama/akita';

export interface ChatUploadState {
	isUploading: boolean;
	isCreating: boolean;
}

@Injectable()
export class ChatUploadStore extends Store<ChatUploadState> {
	constructor() {
		super({}, { name: `ui-chat-upload-${guid()}` });
	}
}
